/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';

/**
 * 
 * @export
 * @interface CreateLocationRequest
 */
export interface CreateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    timeZone: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof CreateLocationRequest
     */
    taxRate: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    externalTerminalId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    externalAchTerminalId?: string | null;
}

/**
 * Check if a given object implements the CreateLocationRequest interface.
 */
export function instanceOfCreateLocationRequest(value: object): value is CreateLocationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('externalTerminalId' in value) || value['externalTerminalId'] === undefined) return false;
    return true;
}

export function CreateLocationRequestFromJSON(json: any): CreateLocationRequest {
    return CreateLocationRequestFromJSONTyped(json, false);
}

export function CreateLocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLocationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'phoneNumber': json['phoneNumber'],
        'timeZone': json['timeZone'],
        'taxRate': BalanceUnitStatementEntryDebitFromJSON(json['taxRate']),
        'description': json['description'],
        'externalTerminalId': json['externalTerminalId'],
        'externalAchTerminalId': json['externalAchTerminalId'] == null ? undefined : json['externalAchTerminalId'],
    };
}

export function CreateLocationRequestToJSON(json: any): CreateLocationRequest {
    return CreateLocationRequestToJSONTyped(json, false);
}

export function CreateLocationRequestToJSONTyped(value?: CreateLocationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'phoneNumber': value['phoneNumber'],
        'timeZone': value['timeZone'],
        'taxRate': BalanceUnitStatementEntryDebitToJSON(value['taxRate']),
        'description': value['description'],
        'externalTerminalId': value['externalTerminalId'],
        'externalAchTerminalId': value['externalAchTerminalId'],
    };
}

